/* eslint-disable no-unused-vars */
import React, { FC } from 'react';
import { ListGroup } from 'react-bootstrap';
import useReorder from '../../../hooks/useReorder/useReorder';
import { TargetListItem } from '../../atoms';
import { ProjectTargetResponseDto } from '../../../store/landscapeAPI/project/dto/response/project-target-response.dto';

interface SortableTargetListProps {
  listItems: ProjectTargetResponseDto[];
  setListItems: (
    items: ProjectTargetResponseDto[],
    from: number,
    to: number
  ) => void;
  handleDelete: (id: string) => void;
  handleOnChange: (projectTarget: ProjectTargetResponseDto) => void;
}

const SortableTargetList: FC<SortableTargetListProps> = ({
  listItems,
  setListItems,
  handleDelete,
  handleOnChange,
}) => {
  const [litems, moveItem] = useReorder<ProjectTargetResponseDto>(
    listItems,
    setListItems,
    true
  );

  return (
    <>
      <ListGroup>
        {litems.length === 0 && <p>Nothing to show.</p>}
        {litems.length > 0 &&
          litems.map((item, index) => {
            return (
              <TargetListItem
                key={item.id}
                listItems={litems}
                listItemsLength={litems.length}
                listItemIndex={index}
                moveListItem={moveItem}
                listItem={item}
                onDeleteClick={handleDelete}
                handleOnChange={handleOnChange}
              />
            );
          })}
      </ListGroup>
    </>
  );
};

export default SortableTargetList;
